import { API_PATHNAME_STG_PROD } from '../constants';
import { defaultEnvironmentValues } from '../index';
export var buildBasePath = function buildBasePath(currentEnv) {
  var _envConfigs$currentEn;
  var envConfigs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEnvironmentValues.envConfigs;
  var baseUrl = envConfigs[currentEnv].api.origin;

  // TypeScript & Safety reasons: Final default to staging-prod API path in case path got overriden somewhere to be undefined, but this should not be the case
  var path = (_envConfigs$currentEn = envConfigs[currentEnv].api.pathname) !== null && _envConfigs$currentEn !== void 0 ? _envConfigs$currentEn : API_PATHNAME_STG_PROD;
  return {
    baseUrl: baseUrl,
    path: path
  };
};